<div class="discount-add">
  <!-- Start discount header -->
  <div class="discount-header mb-0 ui-g-12 p-0">
    <div class="ui-g-12 flex-between-center py-0">
      <div class="flex-start-center width-100p">
        <i class="far fa-badge-percent header-icon"></i>

        <div class="discount-description width-100p p-relative part-input">
          <app-input id="discount-title" type="text" placeholder="Discount name*" styleClassInput="width-100p"
            *ngIf="!companyLocalization" [autoFocus]="true" [maxLength]="100"
            [theme]="focus?.title || !discountItem?.title ? 'secondary' : 'light'" [fontSize]="14"
            [errorMessage]="errors.title" [value]="discountItem.title" [isInvalid]="errors.title"
            (appFocus)="handleFocus('title')" (appBlur)="handleBlur('title')"
            (appChange)="handleChange('title', $event)">
          </app-input>
          <p class="fee-heading" *ngIf="companyLocalization">Discount Details</p>
        </div>
        <i id="discount-close-dialog" class="far fa-times pointer dialog-close" (click)="handleClose()"></i>
      </div>
    </div>
  </div>
  <!-- End discount header -->

  <p-tabView class="ui-g-12 p-0 tab-panel-underline tab-panel-estimates tab-panel-default"
    (onChange)="selectedTab = $event">
    <p-tabPanel [selected]="selectedTab === 0">
      <ng-template pTemplate="header"> Basic info </ng-template>
      <ng-template pTemplate="content">
        <div class="discount-add-body ui-g-12">
          <!-- Start discount application type -->
          <div *ngIf="openFrom !== 'parts-ordering'" class="ui-g-12 p-0 mt-3 customer-type-switch">
            <app-switch-button id="discount-type-switch" valueField="value" paddingClass="p-1"
              [disabled]="discountItemId || openFrom === 'RO'" [fontSize]="14" [showselectedCircle]="false"
              [value]="discountItem?.discountOn" [showIcons]="true" [options]="discountOptions"
              (appChange)="handleChange('discountOn', $event)">
            </app-switch-button>
          </div>
          <!-- End discount application type -->

          <div *ngIf="companyLocalization">
            <div class="ui-g-12 p-0 mt-2">
              <p class="mb-0 font-600">Basic info</p>
            </div>
            <div class="ui-g-12 d-flex" [ngClass]="{'flex-row-reverse': currentLang === 'fr'}">
              <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                <div class="icon flex-center-start">
                  <i class="far fa-badge-percent"></i>
                </div>

                <div class="width-100p pl-1 pr-2">
                  <app-input id="labor-title" type="text"
                    placeholder="Discount name (EN){{ currentLang === 'en'? '*' : '' }}" styleClassInput="width-100p"
                    [maxLength]="100" [fontSize]="14" [value]="discountItem.title" [isInvalid]="errors.title"
                    [errorMessage]="errors.title" (appFocus)="handleFocus('title')" (appBlur)="handleBlur('title')"
                    (appChange)="handleChange('title', $event)">
                  </app-input>
                </div>
              </div>
              <div class=" ui-lg-6 ui-g-6 p-0 flex-start-center">
                <div class="icon flex-center-start">
                  <i class="far fa-badge-percent"></i>
                </div>

                <div class="width-100p pl-1 pr-2">
                  <app-input id="labor-title" type="text"
                    placeholder="Discount name (FR){{ currentLang === 'fr'? '*' : '' }}" styleClassInput="width-100p"
                    [maxLength]="100" [fontSize]="14" [value]="discountItem.titleFR" [isInvalid]="errors.titleFR"
                    (appFocus)="handleFocus('titleFR')" (appBlur)="handleBlur('titleFR')"
                    [errorMessage]="errors.titleFR" (appChange)="handleChange('titleFR', $event)">
                  </app-input>
                </div>
              </div>
            </div>
          </div>

          <!-- Start discount type -->
          <ng-container *ngIf="openFrom !== 'parts-ordering'">
            <div class="ui-g-12 p-0 mt-2">
              <p class="mb-0 font-600">Calculate discount in:</p>
            </div>

            <div class="ui-g-12 p-0 discount-body-row">
              <div class="flex-start-center mt-1 label-12">
                <span class="pr-1 radio-inline">
                  <app-radio-button value="percentage" name="discountType" label="Percentage (%)"
                    [selectedValue]="discountItem?.discountType" (appChange)="handleChange('discountType', $event)">
                  </app-radio-button>
                </span>

                <span class="pr-1 ml-4">
                  <app-radio-button value="value" name="discountType" label="Dollar ($)"
                    [disabled]="order?.invoiceType === 'refund'" [selectedValue]="discountItem?.discountType"
                    (appChange)="handleChange('discountType', $event)">
                  </app-radio-button>
                </span>
              </div>
            </div>
          </ng-container>
          <!-- End discount type -->

          <!-- Start discount details -->
          <div class="ui-g-12 p-0 discount-body-row">
            <div class="ui-g-4 p-0">
              <div *ngIf="discountItem?.discountType === 'value'" class="discount-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-usd-circle"></i>
                </div>
                <!-- Removing entering negative values from discount against ticket ALP-19578 this create confusion to end user as per Product team -->
                <div class="field-input">
                  <app-input id="discount-value" theme="primary" type="text" placeholder="Discount amount*"
                    styleClassInput="width-100p" [selectTextOnFocus]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="focus.discountValue ? discountItem?.discountValue : (discountItem?.discountValue | currency : usd)"
                    [allowDecimal]="focus.discountValue" [isInvalid]="errors?.discountValue"
                    (appFocus)="handleFocus('discountValue')" (appBlur)="handleBlur('discountValue')"
                    (appChange)="handleChange('discountValue', $event)">
                  </app-input>
                </div>
              </div>

              <div *ngIf="discountItem?.discountType === 'percentage'" class="discount-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-percent"></i>
                </div>

                <div class="field-input">
                  <app-input id="discount-value" theme="primary" type="text" placeholder="Discount percentage*"
                    styleClassInput="width-100p" [selectTextOnFocus]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="discountItem?.discountValue" [allowDecimal]="focus.discountValue" suffix="%"
                    [mask]="discountItem?.discountType === 'percentage' && focus.discountValue ? '' : 'percent'"
                    [isInvalid]="errors?.discountValue" (appFocus)="handleFocus('discountValue')"
                    (appBlur)="handleBlur('discountValue')" (appChange)="handleChange('discountValue', $event)">
                  </app-input>
                </div>
              </div>
            </div>

            <div *ngIf="discountItem?.discountType === 'percentage'" class="ui-g-4 p-0">
              <div class="discount-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-info-circle"></i>
                </div>

                <div class="field-input">
                  <app-input id="discount-cap" theme="primary" type="text" placeholder="Max discount*"
                    styleClassInput="width-100p" [selectTextOnFocus]="true" [floatingLabel]="true" [fontSize]="14"
                    [value]="focus.discountCap ? discountItem?.discountCap : discountItem?.discountCap"
                    [allowDecimal]="focus.discountCap" [isInvalid]="errors?.discountCap"
                    (appFocus)="handleFocus('discountCap')" (appBlur)="handleBlur('discountCap')"
                    (appChange)="handleChange('discountCap', $event)">
                  </app-input>
                </div>
              </div>
            </div>
          </div>

          <ng-container *ngIf="isGlobalCategoryEnabled && !isNewCategoriesEnabled">
            <!-- basic info section -->
            <div class="ui-g-12 p-0 mb-3">
              <p class="mb-0 font-600">Basic info</p>
            </div>

            <div class="ui-g-12 p-0 discount-body-row">
              <div class="ui-g-4 p-0">
                <div class="discount-field-wrapper flex-start-center qbo-ref-ddl">
                  <div class="field-icon flex-center-center">
                    <i class="far fa-tags"></i>
                  </div>

                  <div class="field-input">
                    <app-auto-complete id="ac-discount-category" listId="ac-discount-category-list" label="Category"
                      placeholder="Category" field="name" scrollHeight="180px" theme="primary" editableItemIdKey="_id"
                      editFieldLabel="Create Category" [floatingLabel]="true" styleClassInputWrapper="pl-0"
                      styleClassInput="pl-0" [hasEditableField]="true" [hasFutureSelectionField]="false"
                      [closeOnSelection]="true" [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false"
                      [suggestions]="categoryResults" [listItemFontSize]="14" [fontSize]="14"
                      [value]="discountItem.category?.name || ''" (appFocus)="showSuggestions('tags')"
                      (appBlur)="handleBlur('category')" (appUpdateItem)="onUpdateItem($event, config?.tags?.discount)"
                      (appSelect)="onAutoCompleteSelect($event, 'tags')" (appSave)="saveCategory($event)"
                      (appCompletedMethod)="searchSuggestionCategory($event, 'tags')"
                      (appClear)="onClearSuggestion('tags')">
                      <ng-template let-item let-editItem="editItem" appTemplate="item">
                        <div class="tag-item flex-between-center">
                          <div>
                            <span>{{ item?.name }}</span>
                          </div>
                          <div class="tag-item-action flex-end-center">
                            <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                          </div>
                        </div>
                      </ng-template>
                    </app-auto-complete>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Item classfications  -->
          <ng-container *ngIf="isNewCategoriesEnabled">
            <div class="ui-g-12 p-0">
              <p class="mb-0 font-600">Item classification</p>
            </div>
            <div class="input-basic-info-wrapper input-default-style ui-g-12 pt-3 p-0">
              <!-- <h5 class="input-heading">
                Item classification <span><i class="fas fa-info-circle"></i></span>
              </h5> -->

              <div class="ui-g-12 p-0 input-control-container">
                <!-- add flag here -->
                <app-category-search subId="1" [type]="'discount'" [placeholder]="'Search category'"
                  [canEditClassifications]="canEditClassifications"
                  (appSelect)="onSelectCategory($event)"></app-category-search>
              </div>

              <div class="ui-g-12 pt-3 p-0">
                <div class="ui-g-4" [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''"
                  tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center">
                  <app-auto-complete id="standard-category" listId="standard-category-list" field="categoryName"
                    label="Standard Category" placeholder="Standard Category" scrollHeight="186px" theme="light"
                    [value]="discountItem?.category?.categoryName" [fontSize]="14" [listItemFontSize]="14"
                    [floatingLabel]="true" [listItemFontSize]="13" [suggestions]="categoriesSuggestionsResults"
                    [isDropdownIconVisible]="true" (appFocus)="handleFocus('category')"
                    (appBlur)="handleBlur('category')" (appSelect)="categoryDropdownSelect('category', $event)"
                    [isLoading]="loader?.category" [disabled]="!canEditClassifications"
                    (appCompletedMethod)="onSearchItem('category', $event)"
                    (appClear)="handleClear('category')"></app-auto-complete>
                </div>
                <div class="ui-g-4" [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''"
                  tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center">
                  <app-auto-complete id="standard-subcategory" listId="standard-subcategory-list"
                    field="subCategoryName" label="Standard Subcategory" placeholder="Standard Subcategory"
                    scrollHeight="186px" theme="light" [value]="discountItem.category?.subCategoryName" [fontSize]="14"
                    [listItemFontSize]="14" [floatingLabel]="true" [listItemFontSize]="13"
                    [suggestions]="subCategoriesSuggestions" [isDropdownIconVisible]="true"
                    [isLoading]="loader?.subCategory"
                    [disabled]="!discountItem.category?.categoryId  || !canEditClassifications"
                    (appFocus)="handleFocus('subCategory')" (appBlur)="handleBlur('subCategory')"
                    (appSelect)="categoryDropdownSelect('subCategory', $event)"
                    (appCompletedMethod)="onSearchItem('category', $event)"
                    (appClear)="handleClear('category')"></app-auto-complete>
                </div>
                <div class="ui-g-4" [pTooltip]="!canEditClassifications ? classificationPrivilegeMsg : ''"
                  tooltipPosition="top" tooltipStyleClass="tooltip-width-medium text-center">
                  <app-auto-complete id="standard-discount-type" listId="standard-discount-type-list"
                    field="subSubCategoryName" label="Standard Discount Type" placeholder="Standard Discount Type"
                    scrollHeight="186px" theme="light" [value]="discountItem.category?.subSubCategoryName"
                    [fontSize]="14" [listItemFontSize]="14" [floatingLabel]="true" [listItemFontSize]="13"
                    [disabled]="!discountItem.category?.subCategoryId  || !canEditClassifications"
                    [isLoading]="loader?.subSubCategory" [suggestions]="subSubCategoriesSuggestionsResults"
                    [isDropdownIconVisible]="true" (appFocus)="handleFocus('subSubCategory')"
                    (appBlur)="handleBlur('subSubCategory')"
                    (appSelect)="categoryDropdownSelect('subSubCategory', $event)"
                    (appCompletedMethod)="onSearchItem('subSubCategory', $event)"
                    (appClear)="handleClear('subSubCategory')"></app-auto-complete>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- Item classfications  end-->

          <!-- Start general settings -->
          <div class="ui-g-12 p-0">
            <p class="mb-0 font-600">General Settings</p>
          </div>

          <div class="ui-g-12 p-0 discount-body-row">
            <div class="ui-g-4 p-0">
              <div class="discount-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-info-circle"></i>
                </div>

                <div class="field-input">
                  <app-switch-pill id="discount-active" [label]="discountItem?.status ? 'Active': 'Inactive'" position="end" styleClassLabel="font-gray-35"
                    [disabled]="isDefault" [fontSize]="12" [isActive]="discountItem?.status"
                    (appChange)="handleChange('status', $event)">
                  </app-switch-pill>
                </div>
              </div>
            </div>

            <div class="ui-g-8 p-0">
              <div class="discount-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center" *ngIf="discountItem?.discountOn?.value === 'service'">
                  <i class="far fa-dollar-sign"></i>
                </div>

                <div class="field-icon flex-center-center" *ngIf="discountItem?.discountOn?.value === 'order'">
                  <i class="far fa-file-invoice"></i>
                </div>

                <div class="field-input" *ngIf="discountItem?.discountOn?.value === 'service'">
                  <app-switch-pill id="discount-taxable" label="Taxable" position="end" styleClassLabel="font-gray-35"
                    [fontSize]="12" [isActive]="discountItem?.isTaxable"
                    (appChange)="handleChange('isTaxable', $event)">
                  </app-switch-pill>
                </div>

                <div class="field-input" *ngIf="discountItem?.discountOn?.value === 'order'">
                  <app-switch-pill id="discount-display-hour" label="Display qty. & price on estimate & invoice"
                    position="end" styleClassLabel="font-gray-35" [fontSize]="12"
                    [isActive]="discountItem?.displayHoursOnOrder"
                    (appChange)="handleChange('displayHoursOnOrder', $event)">
                  </app-switch-pill>
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g-12 p-0 discount-body-row">
            <div class="ui-g-4 p-0">
              <!-- Qbo Reference -->
              <div class="discount-field-wrapper flex-start-center qbo-ref-ddl" *ngIf="isQboConnected">
                <div class="field-icon flex-center-center">
                  <i class="far fa-coins"></i>
                </div>

                <div class="field-input">
                  <app-auto-complete id="discount-qbo-ref" label="QBO item reference" placeholder="QBO item reference"
                    theme="primary" scrollHeight="179px" name="qboRef" styleClassInputWrapper="pl-0"
                    styleClassInput="pl-0" field="title" [value]="discountItem?.qboRef?.title" [fontSize]="14"
                    [listItemFontSize]="14" [suggestions]="qboItemRefs" [isDropdownIconVisible]="true"
                    [floatingLabel]="true" (appFocus)="handleFocus('qboRef')" (appBlur)="handleBlur('qboRef')"
                    (appClear)="handleClear()" (appSelect)="handleChange('qboRef', $event)"
                    (appCompletedMethod)="handleQboRefSearch($event)">
                  </app-auto-complete>
                </div>
              </div>
            </div>
            <div class="ui-g-4 p-0" *ngIf="discountItem?.discountOn?.value === 'service'">
              <div class="discount-field-wrapper flex-start-center">
                <div class="field-icon flex-center-center">
                  <i class="far fa-file-invoice"></i>
                </div>

                <div class="field-input">
                  <app-switch-pill id="discount-display-hour" label="Display qty. & price on estimate & invoice"
                    position="end" styleClassLabel="font-gray-35" [fontSize]="12"
                    [isActive]="discountItem?.displayHoursOnOrder"
                    (appChange)="handleChange('displayHoursOnOrder', $event)">
                  </app-switch-pill>
                </div>
              </div>
            </div>
          </div>
          <!-- End general settings -->

          <!-- Start notes -->
          <div class="ui-g-12 p-0 discount-body-row ">
            <div *ngIf="companyLocalization else descriptionLocalizationFlag">
              <div class="d-flex" [ngClass]="{'flex-column-reverse': currentLang === 'fr'}">
                <div class="discount-field-wrapper flex-start-center description-wrapper"
                  [ngClass]="{'mt-3':currentLang ==='fr'}">
                  <div class="field-icon flex-center-center">
                    <i class="far fa-stream"></i>
                  </div>

                  <div class="field-input">
                    <app-textarea id="discount-description" textAreaId="discount-description-textarea" theme="primary"
                      type="text" placeholder="Discount description (EN)" styleClassInput="width-100p"
                      [floatingLabel]="true" [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14"
                      [value]="discountItem?.description" [isInvalid]="errors.description"
                      (appFocus)="handleFocus('description')" (appBlur)="handleBlur('description')"
                      (appChange)="handleChange('description', $event)">
                    </app-textarea>
                  </div>
                </div>
                <div class="discount-field-wrapper flex-start-center description-wrapper"
                  [ngClass]="{'mt-3':currentLang ==='en'}">
                  <div class="field-icon flex-center-center">
                    <i class="far fa-stream"></i>
                  </div>

                  <div class="field-input">
                    <app-textarea id="discount-description" textAreaId="discount-description-textarea" theme="primary"
                      type="text" placeholder="Discount description (FR)" styleClassInput="width-100p"
                      [floatingLabel]="true" [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14"
                      [value]="discountItem?.descriptionFR" [isInvalid]="errors.descriptionFR"
                      (appFocus)="handleFocus('descriptionFR')" (appBlur)="handleBlur('descriptionFR')"
                      (appChange)="handleChange('descriptionFR', $event)">
                    </app-textarea>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #descriptionLocalizationFlag>
              <div class="discount-field-wrapper flex-start-center description-wrapper">
                <div class="field-icon flex-center-center">
                  <i class="far fa-stream"></i>
                </div>
                <div class="field-input">
                  <app-textarea id="discount-description" textAreaId="discount-description-textarea" theme="primary"
                    type="text" placeholder="Discount description" styleClassInput="width-100p" [floatingLabel]="true"
                    [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14"
                    [value]="discountItem?.description" [isInvalid]="errors.description"
                    (appFocus)="handleFocus('description')" (appBlur)="handleBlur('description')"
                    (appChange)="handleChange('description', $event)">
                  </app-textarea>
                </div>
              </div>
            </ng-template>

            <div class="discount-field-wrapper flex-start-center description-wrapper mt-3">
              <div class="field-icon flex-center-center">
                <i class="far fa-stream"></i>
              </div>

              <div class="field-input">
                <app-textarea id="internal-disc-desc" textAreaId="internal-disc-desc-textarea" theme="primary"
                  type="text" placeholder="Internal notes" styleClassInput="width-100p" [floatingLabel]="true"
                  [maxAutoGrowHeight]="64" [rows]="1" [autoGrow]="true" [fontSize]="14"
                  [value]="discountItem?.internalNotes" [isInvalid]="errors.internalNotes"
                  (appFocus)="handleFocus('internalNotes')" (appBlur)="handleBlur('internalNotes')"
                  (appChange)="handleChange('internalNotes', $event)">
                </app-textarea>
              </div>
            </div>
          </div>
          <!-- End notes -->
        </div>

        <div class="discount-add-footer ui-g-12">
          <div class="flex-between-center">
            <div class="footer-left">
              <div>
                <span *ngIf="!discountItemId && !orderServiceId" class="width-100p">
                  <app-checkbox inputId="cb-discount-add-another" label="Add another" [isChecked]="isCreateMultiple"
                    (appChange)="isCreateMultiple = $event"></app-checkbox>
                </span>

                <span *ngIf="(orderServiceId || isOpenFromPO) && discountItemId" class="width-100p"
                  [ngClass]="{ invisible: !isOpenFromPO && (isLocal || !orderServiceId) }">
                  <app-checkbox inputId="discount-add-another" label="Also update discount across application"
                    [isChecked]="updateGenericItem"
                    (appChange)="updateGenericItem = $event; discountItem.status = defaultActiveState">
                  </app-checkbox>
                </span>
              </div>
            </div>

            <div class="footer-right">
              <button id="discount-cancel-btn" class="btn btn-border pointer btn-width mr-2"
                (click)="handleClose()">Cancel</button>

              <button id="discount-save-btn" class="btn btn-primary btn-submit btn-width" tooltipPosition="top"
                [pTooltip]="isLockedRO ? 'Sorry, cannot make any changes to a Locked RO':isFinalizedRo ? 'Sorry, cannot make any changes to a finalized RO' : ''"
                [disabled]="isCheckingUniqueness || isSaving || isLoading || isFinalizedRo || isLockedRO"
                (click)="handleSubmit()">
                <span [ngClass]="{ 'pr-2': isSaving || isLoading }">Save</span>
                <i *ngIf="isSaving || isLoading" class="far fa-spinner rotate"></i>
              </button>
            </div>
          </div>
        </div>
      </ng-template></p-tabPanel>

    <p-tabPanel [selected]="selectedTab === 1">
      <ng-template pTemplate="header"> Activity logs </ng-template>
      <ng-template pTemplate="content">
        <div class="activity-logs">
          <div class="catalog-activity-wrapper">
            <!-- Activity logs -->
            <div *ngIf="activityLogs?.length" class="catalog-activity-inner-wrapper">
              <div *ngFor="let activityLog of activityLogs">
                <app-catalog-activity-logs [activityLog]="activityLog"></app-catalog-activity-logs>
              </div>
            </div>

            <div *ngIf="!activityLogs?.length" class="catalog-activity-inner-wrapper no-activity-logs p-3">
              <p>There are no activity logs.</p>
            </div>
          </div>
        </div>
      </ng-template>
    </p-tabPanel>
  </p-tabView>
</div>